module.exports = __webpack_public_path__ + "img/Bathroom01.0150d1c5.png";